module.exports = __webpack_public_path__ + "static/media/IMG-2.2c904ab2.jpg";